import React from 'react';
import { TextField } from '@mui/material';

export default function ConcurrentRequestsField({
  value,
  onChange,
  disabled = false,
  error = false,
}) {
  return (
    <TextField
      label='Concurrent Requests'
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
      error={error}
      type='number'
      slotProps={{ htmlInput: { min: 1, step: 1 } }}
      helperText={error ? 'Must be a positive integer' : ''}
    />
  );
}
